<template>
  <Tag :value="label" :severity="severity" :class="{ 'animate-pulse': props.status === 'processing' }" />
</template>

<script setup lang="ts">
const props = defineProps<{ status: string | null | undefined }>();

const statusConfig: Record<string, { label: string; severity: 'success' | 'info' | 'warn' | 'danger' | 'secondary' }> = {
  pending_payment: { label: 'Pending Payment', severity: 'warn' },
  submitted: { label: 'Submitted', severity: 'info' },
  processing: { label: 'Processing', severity: 'info' },
  approved: { label: 'Approved', severity: 'success' },
  rejected: { label: 'Rejected', severity: 'danger' },
  collected: { label: 'Collected', severity: 'secondary' },
};

const normalised = computed(() => (props.status ?? '').toString().toLowerCase());
const label = computed(() => statusConfig[normalised.value]?.label ?? props.status ?? '—');
const severity = computed(() => statusConfig[normalised.value]?.severity ?? 'info');
</script>
